import { http } from "../http-common";

const getReport = (category) => {
  return http.get(`/report?category=${category}`);
};

const getFuntionalityOptions = () => {
  return http.get(`/functionalities`);
};

const createProfileRegistration = (data) => {
  return http.post("/profile", data);
};

const updateProfileRegistration = (data) => {
  return http.put(`/profile`, data);
};

const getProfilesSearchQuery = (query,pageModel) => {
  return http.get(
    `/profile/find?profileCode=${query}&profileName=${query}&pageNumber=${pageModel.page}&size=${pageModel.pageSize}`
  );
};

const ReportService = {
  getReport,
  getFuntionalityOptions,
  createProfileRegistration,
  updateProfileRegistration,
  getProfilesSearchQuery,
};

export default ReportService;
